import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'


import { RootState } from 'src/redux/store'
import { Toaster, toast } from 'sonner'

import { ENUM_STATUS_CODE } from 'src/helpers'
import { useLocation } from 'react-router-dom'
import { errorReducerState, updateResetError } from 'src/redux/Slicer/errorHadlingSlicer'
const ErrorBoundryMain = () => {
    const { errorMessage, isError, isWarning, warningMessage, errorCode, successMessage } = useSelector((state: RootState) => errorReducerState(state))
    // const { toast } = useToast();
    const dispatch = useDispatch()
    
    const { pathname } = useLocation()
    // console.log(pathname)
    useEffect(() => {
        if (isError) {
            if(errorMessage){
                // console.log(errorMessage)
                toast.error(errorMessage)
            }
            
        }
        else if (isWarning) {
            toast.warning(warningMessage)
        }
        dispatch(updateResetError())

    }, [errorMessage, isError, isWarning, warningMessage])

    useEffect(() => {
        if (errorCode === ENUM_STATUS_CODE?.AUTHENDICATE) {

            // logout()
        } else if (errorCode === ENUM_STATUS_CODE?.SUCCESS && successMessage !== '' &&successMessage !== undefined ) {
            toast.success(successMessage)
        }
        dispatch(updateResetError())
    }, [errorCode, successMessage])
    return (
        <div>
{ pathname.includes('auth')? <Toaster position="top-center" richColors />: <Toaster position="top-right" richColors />}
            {/* <Toaster position="top-right" richColors /> */}
        </div>
    )
}

export default ErrorBoundryMain
